import zlib from "zlib";

export function gzipcompress(data: string): string {
  const compressed = zlib.gzipSync(Buffer.from(data));
  return compressed.toString("base64");
}

export function gzipdecompress(data: string): string {
  const unzipped = zlib.unzipSync(Buffer.from(data, "base64"));
  return unzipped.toString();
}
